export default "__VITE_ASSET__BiUbGqzl__"